export default __webpack_public_path__ + "static/hitech-alexa-retail-0febd8c5f37ce97f8ae42f931be8d195.png";